import { getMobilePlanOffers } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function getPriceOptions(offer: MobilePlanOffer) {
  return {
    keepPhoneNumber: offer.priceOptions.find(
      (priceOption) => priceOption.option === 'KEEP_PHONE_NUMBER',
    ),
    newPhoneNumber: offer.priceOptions.find(
      (priceOption) => priceOption.option === 'NEW_PHONE_NUMBER',
    ),
  }
}

export function getOfferPriceOptions(
  offers: MobilePlanOffer[],
  offerName: string,
) {
  const bouyguesOffer = offers.find((offer) => offer.name === offerName)

  if (!bouyguesOffer) {
    throw new Error(
      `Offer named ${offerName} is not part of the fetched offers`,
    )
  }

  return getPriceOptions(bouyguesOffer)
}

export async function useBouyguesOffers() {
  const { market } = useMarketplace()

  const {
    data: offers,
    pending,
    error,
    refresh,
  } = await useHttpFetch(getMobilePlanOffers, {
    queryParams: {
      marketCode: market.countryCode,
      partner: 'BOUYGUES_TELECOM',
    },
  })

  return { offers, pending, error, refresh }
}
